import React from "react";
import "./Leistungsbausteine.css";
import {
  CheckCircle,
  Search,
  Lightbulb,
  FileText,
  Users,
  Megaphone,
  Globe,
} from "lucide-react";

const panels = [
  { title: "Erstberatung", description: "Wir führen eine erste Beratung durch.", icon: <CheckCircle size={48} /> },
  { title: "Bestandsanalyse", description: "Analyse des aktuellen Wärmeplans.", icon: <Search size={48} /> },
  { title: "Potentialanalyse", description: "Wir identifizieren Potenziale für erneuerbare Wärme.", icon: <Lightbulb size={48} /> },
  { title: "Konzepterstellung", description: "Erstellung eines Konzeptes zur Wärmeplanung.", icon: <FileText size={48} /> },
  { title: "Präsentation", description: "Wir präsentieren das Konzept.", icon: <Users size={48} /> },
  { title: "Bürgerkommunikation", description: "Information der Bürger:innen.", icon: <Megaphone size={48} /> },
  { title: "Veröffentlichung", description: "Finale Veröffentlichung der Ergebnisse.", icon: <Globe size={48} /> },
  { title: "Follow-up", description: "Wir begleiten Sie bei der Umsetzung.", icon: <CheckCircle size={48} /> },
];

const Leistungsbausteine: React.FC = () => {
  return (
    <section>
      <div className="container">
        <h2 className="page-heading">Leistungsbausteine</h2>
        <div className="steps-grid">
          {panels.map((panel, index) => (
            <div key={index} className="step-card">
              <div className="icon">{panel.icon}</div>
              <h3>{panel.title}</h3>
              <p>{panel.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Leistungsbausteine;
